import { map } from 'rxjs/operators';
import { filter, Observable, of } from 'rxjs';
import { Maybe, Site, SiteNameGQL } from '@iss/libs/graphql';
import {
  ChangeDetectorRef,
  inject,
  OnDestroy,
  Pipe,
  PipeTransform,
} from '@angular/core';
import { AsyncPipe } from '@angular/common';

@Pipe({ name: 'siteName', pure: false, standalone: true })
export class SiteNamePipe implements PipeTransform, OnDestroy {
  private readonly siteName = inject(SiteNameGQL);
  private readonly asyncPipe = new AsyncPipe(inject(ChangeDetectorRef));
  private id?: Maybe<Site['id']>;
  private siteName$!: Observable<string | null>;

  public transform(id: Maybe<Site['id']>): string | null {
    if (this.id !== id) {
      this.id = id;
      this.siteName$ = id ? this.fetch(id) : of(null);
    }

    return this.asyncPipe.transform(this.siteName$);
  }

  public ngOnDestroy(): void {
    this.asyncPipe.ngOnDestroy();
  }

  protected fetch(id: Site['id']): Observable<string> {
    return this.siteName.fetch({ id }).pipe(
      map(({ data }) => data),
      filter(Boolean),
      map(({ site }) => site.name),
    );
  }
}
